document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function (mutations, obs) {
    const swatchInputs = document.querySelectorAll('.spb-productoptionswatchwrapper input[type="radio"]');
    if (swatchInputs.length === 0) return;

    // Inputs are now available — set up listeners
    swatchInputs.forEach(input => {
      // Avoid double-binding
      if (input.dataset.listenerAttached) return;

      input.addEventListener('change', function () {
        const swatchWrapper = this.closest('.spb-productoptionswatchwrapper');
        const labelEl = swatchWrapper.querySelector('.spb-swatchlabel');
        if (!labelEl) return;

        const swatchLabel = labelEl.textContent.trim();

        // Find the first image whose alt includes this label
        const mediaImgs = document.querySelectorAll('.product__media-item img');
        let matchedMediaId = null;

        for (const img of mediaImgs) {
          const altText = img.getAttribute('alt') || '';
          if (altText.includes(swatchLabel)) {
            const mediaItem = img.closest('.product__media-item');
            if (mediaItem) {
              matchedMediaId = mediaItem.getAttribute('data-media-id');
              break;
            }
          }
        }

        if (matchedMediaId) {
          const thumbButton = document.querySelector(`.product__thumbnail-item[data-media-id="${matchedMediaId}"]`);
          if (thumbButton) {
            thumbButton.click();
          }
        }
      });

      // Mark as initialized
      input.dataset.listenerAttached = "true";
    });

    // We found and initialized inputs, stop observing
    obs.disconnect();
  });

  // Start observing the body for additions
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
